import { useNavigate } from 'react-router';

const ToolInvalidPathRedirector = () => {
  const navigate = useNavigate();

  navigate(-1);

  return <></>;
};

export default ToolInvalidPathRedirector;
